(function () {
if (typeof window.StorefrontLayoutAPI === 'undefined') {
    window.StorefrontLayoutAPI = {};
}

if (typeof window.StorefrontLayoutContext == 'undefined') {
    window.StorefrontLayoutContext = {};
}

StorefrontLayoutContext.CustomEvents = {
    SwymWishlistFetched: "SwymWishlistFetched",
    SwymWishlistAsyncApisInitialized: "SwymWLAsyncApisInitialized"
}


const swymInitWishlistAsyncApi = (swat) =>{
    const SwymWishlistDefaultName = swat.retailerSettings.UI.Title;

    const SwymWLAsyncApis = {
        'fetchLists': async function(){
            return new Promise(async (resolve, reject) => {
                swat.api.fetchLists({
                    callbackFn: lists => resolve(lists),
                    errorFn: err => reject(err)
                });
            });
        },
        'fetchListDetails': async function (lid){
            return new Promise(async (resolve, reject) => {
                swat.api.fetchListDetails(
                    { lid: lid },
                    listContents => resolve(listContents),
                    error => reject(error)
                );
            });
        },
        'fetchListProductsDetails': async function (lid){
            return new Promise(async (resolve, reject) => {
                swat.api.fetchListCtx(
                    { lid: lid },
                    listContents => resolve(listContents),
                    error => reject(error)
                );
            });
        },
        'createList': function (listName = SwymWishlistDefaultName) {
            return new Promise((resolve, reject) => {
                swat.utils.debounce(() => {
                    let listConfig = { "lname": listName };
                    swat.api.createList(
                        listConfig,
                        list => resolve(list),
                        error => reject(error)
                    );
                }, 1000)();
            });
        },
        'renameList': function(lid, lname = SwymWishlistDefaultName) {
            let listUpdateConfig = { 
                lname,
                lid 
            }
            return new Promise(async (resolve, reject) => {
                swat.api.updateList(listUpdateConfig, 
                    list => resolve(list),
                    error => reject(error)
                );
            })
        },
        'deleteLists': async function (lists) {
            try {
                await Promise.all(lists.map(list => 
                    new Promise((resolve, reject) => {
                        swat.api.deleteList(
                            list.lid,
                            obj => resolve(obj), 
                            error => reject(error)
                        );
                    })
                ));
                return { success: true };
            } catch (error) {
                swat.utils.error('Error encountered while deleting the list', error);
                throw error;
            }
        },
        'addProductsToList': async function (products, lid){
            return new Promise(async (resolve, reject) => {
                swat.api.addProductsToList(
                    lid,
                    products,
                    products => resolve(products),
                    error => reject(error)
                )
            })
        },
        'removeProductFromList': async function (product, lid){
            return new Promise(async (resolve, reject) => {
                swat.api.deleteFromList(
                    lid,
                    product,
                    deletedProduct => resolve(deletedProduct),
                    error => reject(error)
                )
            })
        },
        'updateProductFromList': async function (product, lid){
            return new Promise(async (resolve, reject) => {
                swat.api.updateListItem(
                    lid,
                    product,
                    updatedListItem => resolve(updatedListItem),
                    error => reject(error)
                )
            })
        },
        'getListsProducts': async function (lists) {
            return Object.values(
                (
                await Promise.all(
                    lists.map(async (list) => 
                        SwymWLAsyncApis.fetchListProductsDetails(list.lid)
                    )
                )
                )
                .flat()
                .reduce((acc, { epi, empi, du }) => {
                    acc[epi] = { epi, empi, du };
                    return acc;
                }, {})
            );
        },
        'generateSharedListURL': async function (lid){
            return new Promise(async (resolve, reject) => {
                swat.api.generateSharedListURL(
                    lid,
                    link => resolve(link),
                    error => reject(error)
                );
            });
        },
        'fetchProductData': async function(list = [], fromCache = false){
            const productDataPromises = list.map(async (listItem) => {
                try{
                    if (fromCache && StorefrontLayoutContext.ShopifyProductData && StorefrontLayoutContext.ShopifyProductData[listItem.epi]) {
                        listItem.productData = StorefrontLayoutContext.ShopifyProductData[listItem.epi];
                    } else {
                        const response = await fetch(`${listItem.du.split("?")[0]}.js`);
                        if (!response.ok) {
                        return null
                        }
                        listItem.productData = await response.json();
                        StorefrontLayoutContext.ShopifyProductData[listItem.epi] = listItem.productData;
                    }
                    return listItem;
                }catch (error) {
                    swat.utils.error(`Error fetching product data for ${listItem.du}`, error);
                    return null;
                }
            });
            const results = await Promise.all(productDataPromises)
            return results.filter((item) => item !== null);
        },
        'init': async function() {

            SwymWLAsyncApis.updateList();
        
            swat.utils.log('Swym fetch default list - SUCCESS');
                
        },
        'updateList':async function() {
            let defaultList = null;
            let collections = [];
            let lists = [];

            try{
                const isMultiListEnabled = swat.retailerSettings?.Wishlist?.EnableCollections;

                lists = (await SwymWLAsyncApis.fetchLists()) || []; 
                lists = lists?.sort((a, b) =>  a.cts - b.cts);

                defaultList = isMultiListEnabled? lists[0] : lists.find((item) => item.lname.toLowerCase() === SwymWishlistDefaultName.toLowerCase()) || lists[0];
                if(StorefrontLayoutContext.Settings?.EnableStorefrontLayoutCollection){
                    collections = lists.filter((item) => item.lid !== defaultList?.lid );
                    collections?.sort((a, b) =>  b.cts - a.cts);
                }
            }catch(error){
                swat.utils.error(`Error fetching list`, error);
            }
            
            StorefrontLayoutContext.DefaultList = defaultList;
            StorefrontLayoutContext.collections = collections;
            StorefrontLayoutContext.lists = [
              ...(defaultList != null ? [defaultList] : []), 
              ...collections];
            StorefrontLayoutContext.allLists = lists;

            var event = new CustomEvent(StorefrontLayoutContext.CustomEvents.SwymWishlistFetched, { 
                detail: { defaultList, collections, lists }
            });
            document.dispatchEvent(event);

            return lists;
        }
    }

    StorefrontLayoutAPI.SwymWLAsyncApis = SwymWLAsyncApis;
    const event = new CustomEvent(StorefrontLayoutContext.CustomEvents.SwymWishlistAsyncApisInitialized, { detail: { SwymWLAsyncApis } });
    document.dispatchEvent(event);
} 

if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymInitWishlistAsyncApi);
})();